import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { ApiError } from '@/lib/api';

/**
 * Wraps protected routes. While auth resolves we show a minimal splash;
 * on 401 we redirect to /login preserving the next-URL.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const { user, loading, error } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-text-muted">
        Loading…
      </div>
    );
  }

  const is401 = error instanceof ApiError && error.status === 401;
  if (is401 || (!loading && !user)) {
    const next = location.pathname + location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }

  return <>{children}</>;
}
